import styled from 'styled-components';
import { BLACK } from 'root/theme';
import media from '../../oldpantheon/utils/media';

export const HeaderContainer = styled.div`
  text-align: center;
  max-width: 35rem;
  margin: 0 auto;

  ${media.extraSmall`
    max-width: unset;
    width: 92%;
  `}
`;

export const HeroSubTitle = styled.h2`
  font-size: 1.5rem;
  text-align: center;
  font-family: "Calistoga";
  color: ${BLACK};
  ${media.extraSmall`
    text-align: center;
    margin: 0rem;
  `}
`;

export const CardContainer = styled.div`
  display: flex; 
  flex-direction: row;
  justify-content: space-between;  
  width: 70%;
  max-width: 62.5rem;
  margin: 3rem auto 0 auto;
  ${media.large`
    width: 80%;
  `}

  ${media.medium`
    flex-direction: column;
    width: 100%;
    justify-content: center;
  `}
`;

export const HeroHeader = styled.h1`
  font-weight: 700;
  font-size: 2.75rem;
  margin-bottom: 0;
  ${media.extraSmall`
    font-size: 2rem;
    margin: 0 auto 1.5rem auto;
    width: 85%;
  `}
`;

export const HeroBody = styled.p`
  text-align: center;
  margin-top: 0;
  margin-bottom: 2rem;
  color: ${BLACK};
`;
